<template>
    <b-form-group :label="item.title" :description="item.helpText" label-class="mb-0 pb-0 label-title">
       <Datepicker v-model="dateValue" :disabled-dates="disabledDates" :bootstrap-styling="true" :clear-button="true" :format="dateFormat" />
    </b-form-group>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import FormItem from './FormItem'

    export default {
        name: "DateFormItem",
        extends: FormItem,
        props: ['item'],
        data: function() {
            return {
                dateFormat: 'dd/MM/yyyy',
                dateValue: null,
            }
        },
        methods:
        {
         setDate: function()
         {
           if (this.item.value != null && this.item.value !== '' && this.item.value.length === 10) {
             this.dateValue = this.moment(this.item.value, 'YYYY-MM-DD').toDate();
           }
         }
        },
        watch:
        {
          dateValue: function (newValue)
          {
            if (newValue)
            {
              this.item.value = this.moment(newValue).format('YYYY-MM-DD');
            }
          },
          item:
          {
            immediate: true,
            deep: true,
            handler(val, oldVal)
            {
              this.setDate();
            }
          }
        },
        computed: {
            disabledDates() {
                if(this.item.identifier === "DiaryReminderDate") {
                    return { to: this.moment().toDate() }
                }
            }
        },
        components: {Datepicker},
        created: function() {
            this.setDate();
        }
    }
</script>

<style scoped>
    label, legend.col-form-label {
        font-weight: bold;
    }
</style>